import { Injectable } from '@angular/core';
import gql from 'graphql-tag/index';
import { Apollo } from 'apollo-angular';

// by default, this client will send queries to `/guide/graphql` (relative to the URL of your app)

@Injectable()
export class FacilityInfoService {
  constructor(private apollo: Apollo) {}

  getFacility(id: string, utilStartYear = '2024', utilEndYear = '2024') {
    const query = gql`
      query GetFacility($id: String, $utilStartYear: String, $utilEndYear: String) {
        getFacility(id: $id, utilStartYear: $utilStartYear, utilEndYear: $utilEndYear) {
          ahaId
          ahaMember
          medicareProviderId
          url
          name
          phone
          individuals(exclude: []) {
            name
            title
            guideLabel
          }
          locationAddress {
            street
            state
            city
            county
            zip
          }
          approvalCodes
          physicianCodes
          facilityCodes
          control
          nonreporting
          nursingBeds
          service
          utilization {
            surveyYear
            util {
              label
              text
            }
          }
          affiliatedUnits {
            ahaId
            name
            orgType
            service
            phone
            street
            city
            state
            zip
          }
          system {
            name
            city
            state
            systemId
          }
          parentUnit {
            ahaId
            parentName
          }
        }
      }
    `;

    return this.apollo.watchQuery<any>({
      query: query,
      variables: {
        id: id,
        utilStartYear: utilStartYear,
        utilEndYear: utilEndYear
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/facility-info.service.ts